// css
import css from './../styles/main.less'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)
import loadingBarCss from 'angular-loading-bar/build/loading-bar.css'
import 'bootstrap/js/collapse'
import 'babel-polyfill'

import angular from 'angular'
import uiBootstrap from 'angular-ui-bootstrap'
import uiRouter from '@uirouter/angularjs'
import ngSanitize from 'angular-sanitize'
import loadingBar from 'angular-loading-bar'
import ngFileUpload from 'ng-file-upload'
import dirPagination from 'angular-utils-pagination'
import animationsModule from './animations'
import helpersModule from './helpers'
import homePartial from './../partials/home.html'
import directivesModule from './directives'
import servicesModule from './services'
import authModule from './../client_auth/auth'
import filtersModule from './filters'
import controllersModule from './controllers'
import domainsModule from './../domains'
import analyticsModule from './../analytics_components'
import usersModule from './../users'
import userActionsModule from './../user_actions'
import userDetailModule from './../user_detail'
import userFilterModule from './../user_filter'
import importsModule from './../imports'
import adminEntitiesModule from './../admin_entities'

import Vue from 'vue'
import ngVue from 'ngVue'

let resolveDomain = [
  'graph',
  '$stateParams',
  function(graph, $stateParams) {
    if ($stateParams.domainUuid === 'CONSUMER-DOMAIN-UUID' || $stateParams.domainUuid === '') {
      return { uuid: 'CONSUMER-DOMAIN-UUID', name: '[Consumer domain]' }
    }
    return graph.getDomain($stateParams.domainUuid)
  }
]

angular
  .module('adminPanel', [
    uiRouter,
    ngSanitize,
    uiBootstrap,
    ngFileUpload,
    loadingBar,
    dirPagination,
    helpersModule.name,
    directivesModule.name,
    filtersModule.name,
    animationsModule.name,
    controllersModule.name,
    servicesModule.name,
    authModule.name,
    userFilterModule.name,
    domainsModule.name,
    usersModule.name,
    userActionsModule.name,
    userDetailModule.name,
    analyticsModule.name,
    adminEntitiesModule.name,
    importsModule,
    'ngVue'
  ])
  .value('_build', {
    /* global _GIT_SHA */
    _GIT_SHA,
    /* global _CIRCLE_BUILD_NUM */
    _CIRCLE_BUILD_NUM
  })
  .value('_circleBuildNum', _CIRCLE_BUILD_NUM)
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$qProvider',
    '$httpProvider',
    'configuration',
    function($stateProvider, $urlRouterProvider, $qProvider, $httpProvider, configuration) {
      // suppress errors coming from unhandled promise rejections
      $qProvider.errorOnUnhandledRejections(false)

      /////////////////////////////////
      // HTTP Provider Configuration //
      /////////////////////////////////
      $httpProvider.defaults.withCredentials = true
      $httpProvider.interceptors.push([
        '$rootScope',
        '$q',
        function($rootScope, $q) {
          return {
            responseError: function(response) {
              if (response.status === 401) {
                console.log('Status 401 in interceptor: User not authenticated!')

                $rootScope.$broadcast('Unauthenticated')
              }
              if (response.status === 403) {
                $rootScope.$broadcast('Unauthorized', response.data)
              }
              return $q.reject(response)
            }
          }
        }
      ])

      /////////////////////////////
      // Redirects and Otherwise //
      /////////////////////////////
      $urlRouterProvider.when('/home', '/').otherwise('/')

      //////////////////////////
      // State Configurations //
      //////////////////////////
      $stateProvider
        .state('sign-in', {
          url: '/sign_in',
          template: require('./../client_auth/signIn.html')
        })
        .state('home', {
          url: '/',
          // templateUrl: 'partials/home.html',
          template: homePartial
        })
        .state('import-dashboard', {
          url: '/import_dashboard',
          template: require('./../partials/import_wizard/importDashboard.html'),
          controller: 'ImportDashboardCtrl',
          controllerAs: 'ctrl',
          resolve: {
            completedImports: [
              'adminApi',
              function(api) {
                return api.getCompletedImports(5000)
              }
            ],
            incompleteImports: [
              'adminApi',
              function(api) {
                return api.getIncompleteImports()
              }
            ]
          }
        })

        ///////////////////////
        // Users list routes //
        ///////////////////////
        .state('users-list', {
          template: require('./../users/users.html'),
          url: '/users',
          controller: [function() {}],
          controllerAs: 'ctrl'
        })

        //////////////////////
        // User Info routes //
        //////////////////////
        .state('user-info', {
          url: '/user_info?email&uuid',
          controller: [
            '$stateParams',
            function($stateParams) {
              this.uuid = $stateParams.uuid
              this.email = $stateParams.email
            }
          ],
          controllerAs: 'ctrl',
          template: require('./../user_detail/summary.html')
          // resolve: {
          //   userInfo: ['$stateParams', 'adminApi', function($stateParams, adminApi) {
          //     var email = $stateParams.email;
          //     return adminApi.getUserInfo(email);
          //   }]
          // }
        })
        .state('user-events', {
          url: '/user_events?uuid',
          controller: [
            '$stateParams',
            function($stateParams) {
              this.uuid = $stateParams.uuid
            }
          ],
          controllerAs: 'ctrl',
          template: require('./../user_detail/events.html')
        })
        ///////////////////
        // Domain routes //
        ///////////////////
        .state('domain-index', {
          url: '/domains',
          controller: [function() {}],
          controllerAs: 'domainIndexCtrl',
          template: require('./../domains/domainIndex.html')
        })
        .state('domain-detail', {
          url: '/domains/:uuid',
          controller: [
            'domain',
            function(domain) {
              this.domain = domain
            }
          ],
          controllerAs: 'domainDetailCtrl',
          template: require('./../domains/domainDetailWrapper.html'),
          resolve: {
            domain: [
              '$stateParams',
              'graph',
              function($stateParams, graph) {
                return graph.getDomain($stateParams.uuid)
              }
            ]
          }
        })

        ///////////////////////
        // Import CSV routes //
        ///////////////////////
        .state('import-wizard', {
          abstract: true,
          url: '/import_wizard',
          controller: 'WizardCtrl',
          controllerAs: 'wizardCtrl',
          template: require('./../partials/import_wizard/wizard_layout.html')
        })
        .state('import-wizard.step1', {
          url: '/select_domain',
          template: require('./../partials/import_wizard/_step1_selectDomain.html'),
          controller: 'SelectDomainCtrl',
          controllerAs: 'ctrl'
        })
        .state('import-wizard.step2', {
          url: '/:domainUuid/:importUuid/upload_csv',
          template: require('./../partials/import_wizard/_step2_uploadCSV.html'),
          controller: 'UploadCSVCtrl',
          controllerAs: 'ctrl',
          resolve: {
            domain: resolveDomain,
            importRecord: [
              '$stateParams',
              'adminApi',
              function($stateParams, adminApi) {
                return adminApi.getImportRecord($stateParams.importUuid)
              }
            ]
          }
        })
        .state('import-wizard.import-status', {
          url: '/:domainUuid/:importUuid/status',
          template:
            '<import-status-wizard-page import-uuid="{{$ctrl.importUuid}}" domain="$ctrl.domain"></import-status>',
          controllerAs: '$ctrl',
          controller: [
            '$stateParams',
            'domain',
            function($stateParams, domain) {
              this.importUuid = $stateParams.importUuid
              this.domain = domain
            }
          ],
          resolve: {
            domain: resolveDomain
          }
        })
        .state('import-wizard.step3', {
          url: '/:domainUuid/:importUuid/user_info',
          template: require('./../partials/import_wizard/_step3_userInfo.html'),
          controller: 'ImportUserInfoCtrl',
          controllerAs: 'ctrl',
          resolve: {
            importRecord: [
              '$stateParams',
              'adminApi',
              function($stateParams, adminApi) {
                return adminApi.getImportRecord($stateParams.importUuid)
              }
            ]
          }
        })
        .state('import-wizard.step4', {
          url: '/:domainUuid/:importUuid/licenses',
          template: require('./../partials/import_wizard/_step4_userLicenses.html'),
          controller: 'ImportUserLicensesCtrl',
          controllerAs: 'ctrl'
        })
        .state('import-wizard.step5', {
          url: '/:domainUuid/:importUuid/confirm',
          template: require('./../partials/import_wizard/_step5_confirm.html'),
          controller: 'ConfirmImportCtrl',
          controllerAs: 'ctrl',
          resolve: {
            domain: resolveDomain
          }
        })

        /////////////////
        //Search Routes//
        /////////////////
        .state('search-wizard', {
          template: require('./../partials/search_wizard/search_wizard.html'),
          url: '/search_wizard',
          controller: 'SearchWizardCtrl'
        })

        ///////////////////////
        // Analytics routes //
        ///////////////////////
        .state('analytics', {
          template: require('./../analytics_components/analytics.html'),
          url: '/analytics',
          controller: 'AnalyticsCtrl'
        })
        
        ///////////////////////
        // Admin Entities routes //
        ///////////////////////
        .state('supergroups', {
          template: require('./../admin_entities/supergroups/supergroups.html'),
          url: '/supergroups',
          controller: [function() {}],
          controllerAs: 'supergroupsCtrl'
        })
    }
  ])
  .run([
    '$rootScope',
    '$uibModalStack',
    function($rootScope, $modalStack) {
      $rootScope.$on('$stateChangeStart', function() {
        $rootScope.doingResolve = true
      })
      $rootScope.$on('$stateChangeSuccess', function() {
        $rootScope.doingResolve = false
        $modalStack.dismissAll()
      })
      $rootScope.$on('$stateChangeError', function() {
        $rootScope.doingResolve = false
      })
    }
  ])
  .run([
    'auth',
    'adminApi',
    'analyticsApi',
    'domainInfo',
    'adminEntitiesApi',
    'domoEmbedsApi',
    'graph',
    'userCache',
    'configuration',
    function(auth, adminApi, analyticsApi, domainInfo, adminEntitiesApi, domoEmbedsApi, graph, userCache, config) {
      Vue.mixin({
        data() {
          return {
            $angularWorldMixin: {
              config,
              auth,
              adminApi,
              analyticsApi,
              domainInfo,
              adminEntitiesApi,
              domoEmbedsApi,
              graph,
              userCache
            }
          }
        },
        computed: {
          $angularWorld() {
            return this.$data.$angularWorldMixin
          }
        }
      })
    }
  ])

// manually bootstrap the app after fetching config
;(function getConfigAndStart() {
  var $http = angular.injector(['ng']).get('$http')

  var endPoint = window.location.protocol + '//' + window.location.host + window.location.pathname
  // super hacky thing for dev (with grunt)
  if (window.location.port === '9002' || window.location.port === '8080') {
    endPoint = 'http://localhost/admin/'
  }
  console.log('Getting config from: ' + endPoint)
  $http.get(endPoint + 'config/').then(function(response) {
    // define the config module
    response.data.root = endPoint
    response.data.transformingInstructionHost = 'http://transforming-instruction.herokuapp.com'
    angular.module('adminPanel.services').constant('configuration', response.data)

    // start the app!
    angular.bootstrap(document, ['adminPanel'])
  })
})()